import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  trigger(campaignId) {
    return axios.post(`${this.url}/${campaignId}/trigger`);
  }
}

export default new CampaignsAPI();
